/**
 * Módulo: Rentabilidad
 *
 * ⚠️ NO CONFUNDIR con el motor de rentabilidad, que es otra cosa y no vive acá:
 * el cálculo de plata de verdad está en `functions/rentabilidad.js` (4 capas),
 * `src/core/lib/rentabilidad/` y `rentabilidadEstimada.js`. Este módulo empezó
 * siendo el simulador pre-venta, y hoy lo que queda vivo adentro son piezas
 * COMPARTIDAS que usa media app: `hooks/useImpuestosEmpresa` (10 consumidores,
 * incluido el motor de agentes IA en `src/core/lib/agentes.js`),
 * `hooks/useEventosVenta` (6) y las solapas de Impuestos y Aprendizajes de la
 * ficha de empresa. Por eso el módulo no se borra aunque su página se apague.
 *
 * Su única página, el simulador, está APAGADA desde el 19-ago-2026 — el porqué
 * está escrito en `routes`, abajo.
 */
export default {
  id: 'rentabilidad',
  // Label del grupo en el sidebar (rename Mariano 7-jul). El id/ruta/código del
  // módulo siguen siendo `rentabilidad` — solo cambia la etiqueta visible.
  nombre: 'Analizar Borrar',
  descripcion: 'Impuestos y aprendizajes por empresa (el simulador pre-venta está apagado, ver `routes`)',
  icono: 'dollar-sign',
  tipo: 'comercial',
  version: '0.1.0',
  // Visible para admin MilBrands, consultor y cliente/colaborador de la empresa

  // ── APAGADO 19-ago-2026 (Mariano) — el simulador no se borra, se apaga ──
  // Su panel de envíos NUNCA pudo devolver un número: `calculadorEnvio.js:77`
  // lee `tramosPeso[].tarifas[<ZONA>]` y NINGÚN escritor del repo produce esa
  // clave (grep de `tarifas:` en `functions/`: cero). No es que falte seedear —
  // el lector se escribió contra un formato que **Mercado Libre nunca ofreció**:
  // para la estimación del vendedor su API devuelve `coverage.all_country`, un
  // solo número por país, sin zonas (doc oficial "Costos de envío", act.
  // 13-feb-2026). Las zonas existen sólo en el endpoint del COMPRADOR, y en
  // Chile y Uruguay ni siquiera aceptan código postal: piden ciudad.
  //
  // Y no se pierde nada al apagarlo: la estimación que usan las pantallas de
  // plata —Rentabilidad Inferida, el gate de promos, el precio sugerido, la
  // ficha de producto— sale de `rentabilidadEstimada.js` (`envioPct`, el envío
  // como % del precio calculado sobre las órdenes REALES del vendedor). Ese
  // camino ya incorpora la mezcla real de zonas, los descuentos y el umbral de
  // envío gratis, y funciona por país sin catálogo ninguno.
  //
  // DEUDA DECLARADA, no escondida (consigna permanente): el código de
  // `pages/SimuladorPage.jsx` y `lib/calculadorEnvio.js` QUEDA en el árbol a
  // pedido de Mariano — *"después si lo necesitamos lo hacemos de nuevo, el
  // costo es marginal"*. Trigger para retomarlo: que se decida construir el
  // simulador pre-venta de verdad. Si al llegar ese día sigue sin decidirse,
  // se borra (ADR 055: el código muerto se poda).
  //
  // ⚠️ Lo que este apagado NO hace: los dos crons que llenan los catálogos de
  // envío (`enviosMLA.js`, día 1 y 15 a las 05:00; `catalogoEnvioME2MLA.js`,
  // día 4) SIGUEN corriendo y pegándole a ML para llenar colecciones que ahora
  // no lee nadie. Apagarlos es una decisión operativa aparte.
  routes: [],

  // #87 — `permisoModulo` filtra item-by-item según el rol.
  menuItems: [
    // 'Simulador de costos' — apagado 19-ago-2026, ver el comentario de `routes`.
    // "Calendario" se mudó acá desde GESTIÓN (Mariano 7-jul) — la ruta
    // /calendario sigue en asignaciones/config.js (solo se movió el ítem).
    { label: 'Calendario', path: '/calendario', icon: 'calendar', permisoModulo: 'calendario' },
  ],

  features: [
    // 'rentabilidad-simulador-mla' — apagado 19-ago-2026, ver `routes`.
  ],

  // permisoModulos (#58): se deriva del rol.
  permisoModulos: ['rentabilidad'],

}
